exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n    width: 200px;\n    background-color: gainsboro;\n    border-style: solid;\n    border-color: black;\n    border-width: 1px;\n    border-radius: 2px;\n    box-shadow: 4px 4px 2px darkgrey;\n    padding: 10px;\n}\n\ninput {\n    width: 100%;\n}\n\n.buttons {\n    margin-top: 10px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Grid/filter.component.css
// module id = 445
// module chunks = 1